import React from 'react';
import { Button, Space } from 'antd';
import {
  CheckCircleOutlined,
  CloseCircleOutlined
} from '@ant-design/icons';
import { useTranslation } from '../../../hooks/useTranslation';

export interface ConsultedQuickActionsProps {
  appointment: {
    id: string;
    status: string;
  };
  loadingStates: {
    completing?: boolean;
    cancelling?: boolean;
  };
  handlers: {
    onCompleteAppointment: () => void;
    onCancelAppointment: () => void;
  };
}

const ConsultedQuickActions: React.FC<ConsultedQuickActionsProps> = ({
  appointment,
  loadingStates,
  handlers
}) => {
  const { t } = useTranslation();

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      {/* Complete Appointment Button */}
      <Button
        type="primary"
        icon={<CheckCircleOutlined />}
        block
        onClick={handlers.onCompleteAppointment}
        loading={loadingStates.completing}
      >
        {t('appointments.complete') || 'Complete'}
      </Button>

      {/* Cancel Appointment Button */}
      <Button
        danger
        icon={<CloseCircleOutlined />}
        block
        onClick={handlers.onCancelAppointment}
        loading={loadingStates.cancelling}
      >
        {t('appointments.cancel')}
      </Button>
    </Space>
  );
};

export default ConsultedQuickActions;
